module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/productos/categoria-producto/categoria-producto.component.scss
// module id = ./src/app/productos/categoria-producto/categoria-producto.component.scss
// module chunks = main